module.exports = __webpack_public_path__ + "img/도면_중앙기술연구소.ce2f106b.png";